import React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';

type HilightProps = TypographyProps & {
    text: string;
};

function parseWordsForHilight(text: string): React.ReactNode[] {
    const parts = text.split(/(<[^>]+>)/g);

    return parts.map((part, index) => {
        const match = part.match(/^<(.+)>$/);
        if (match) {
            return <span key={index} style={{color: "#699ceb"}}>{match[1]}</span>;
        } else {
            return <React.Fragment key={index}>{part}</React.Fragment>;
        }
    });
}

export default function Hilight({text, ...props}: HilightProps) {
    return(
        <Typography {...props}>
            {parseWordsForHilight(text)}
        </Typography>
    );
}